import { default as _91_46_46_46slug_93umUAI1cRkfMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/[...slug].vue?macro=true";
import { default as indexBt9vNM1XIqMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/auth/index.vue?macro=true";
import { default as indexf6QlPP6DCCMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/auth/social/[organisation]/[provider]/index.vue?macro=true";
import { default as _91id_93xbZYLrIaJ6Meta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/formProcess/[id].vue?macro=true";
import { default as _91id_935RK1yNB5hAMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/formProcess/success/[id].vue?macro=true";
import { default as _91region_93jAcnUBNKlVMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/jugend-zaehlt/[region].vue?macro=true";
import { default as _91slug_93wD7ic2Qgr8Meta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/news/[slug].vue?macro=true";
import { default as organisationsUE7aLGGlaHMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/organisations.vue?macro=true";
import { default as grouped_45by_45eventsLyFR5eUJdaMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/processes/index/grouped-by-events.vue?macro=true";
import { default as grouped_45by_45funding_45programs4oB2k849rgMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/processes/index/grouped-by-funding-programs.vue?macro=true";
import { default as indexkl1AcByKNpMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/processes/index.vue?macro=true";
import { default as dungeonfDAKgrmowlMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/secret/index/dungeon.vue?macro=true";
import { default as inputsp6SQrWrNQqMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/secret/index/inputs.vue?macro=true";
import { default as indexRTrtjgd2cVMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/secret/index.vue?macro=true";
import { default as indexY0pcp4UwXHMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/categories/index.vue?macro=true";
import { default as formBaseDataNNsZpZg0dXMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/forms/[id]/formBaseData.vue?macro=true";
import { default as formClasspN2v2jzMT8Meta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/forms/[id]/formClass.vue?macro=true";
import { default as _91id_93wLsEzp3UPvMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/forms/[id].vue?macro=true";
import { default as indexMMNRrKH1qtMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/forms/index.vue?macro=true";
import { default as fundingProgramBaseDatauiKHEpjudZMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue?macro=true";
import { default as fundingProgramProcessFieldssyzkTqfRWXMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue?macro=true";
import { default as fundingProgramReportsous7QkEVhKMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue?macro=true";
import { default as fundingProgramRightsz3OVD9VTxUMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue?macro=true";
import { default as _91id_93HDksljwQq4Meta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/fundingPrograms/[id].vue?macro=true";
import { default as index5JihjFTEqBMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/fundingPrograms/index.vue?macro=true";
import { default as mailActivitiesqwghjOrJf6Meta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/mails/[id]/mailActivities.vue?macro=true";
import { default as mailBaseDataxxt862h7pHMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/mails/[id]/mailBaseData.vue?macro=true";
import { default as _91id_935DD3fqwysOMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/mails/[id].vue?macro=true";
import { default as indexIVxVKvofRrMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/mails/index.vue?macro=true";
import { default as mailTemplateActivitiesHXB4RWDyObMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue?macro=true";
import { default as mailTemplateBaseDatabnyQ3XuNRfMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue?macro=true";
import { default as _91id_93NitguLUdVbMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/mailTemplates/[id].vue?macro=true";
import { default as indexKSBNX1U2gTMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/mailTemplates/index.vue?macro=true";
import { default as roleBaseDataVlYhrcZMiUMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/roles/[name]/roleBaseData.vue?macro=true";
import { default as _91name_93uVMRs2GtFCMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/roles/[name].vue?macro=true";
import { default as indexN3IJqYJ6wPMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/roles/index.vue?macro=true";
import { default as statisticFormBaseDatazCX6lGEkxBMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue?macro=true";
import { default as statisticFormClassmq1e0Of4hdMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue?macro=true";
import { default as statisticFormDedicatedFormsOhsw7vsoBlMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue?macro=true";
import { default as _91id_931FhTysK7VwMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/statisticForms/[id].vue?macro=true";
import { default as indexipJBM4Dya1Meta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/statisticForms/index.vue?macro=true";
import { default as statisticSurveyActivitiessO7RyRjmRwMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue?macro=true";
import { default as statisticSurveyBaseDatamBOLp0UroxMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue?macro=true";
import { default as statisticSurveyPeriodseHz6EDxUD0Meta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue?macro=true";
import { default as _91id_93Ap0AjUn9fFMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/statisticSurveys/[id].vue?macro=true";
import { default as indexrDjYRTNduIMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/statisticSurveys/index.vue?macro=true";
import { default as statusActivitiesBkMgTf6JmxMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/statuses/[id]/statusActivities.vue?macro=true";
import { default as statusBaseData0VConUKtjcMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/statuses/[id]/statusBaseData.vue?macro=true";
import { default as statusNotificationsf8QSjtcSA4Meta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/statuses/[id]/statusNotifications.vue?macro=true";
import { default as _91id_93cqaVtgYAwoMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/statuses/[id].vue?macro=true";
import { default as indexwpqPgLNDfxMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/statuses/index.vue?macro=true";
import { default as yearBaseDataSJPUvxvw6VMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/years/[id]/yearBaseData.vue?macro=true";
import { default as yearDataAUyQbC66PhMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/years/[id]/yearData.vue?macro=true";
import { default as _91id_93lQqWff11HSMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/years/[id].vue?macro=true";
import { default as indexKiqlrxtAwVMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/years/index.vue?macro=true";
import { default as basicDataG1qkpwsSSWMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData.vue?macro=true";
import { default as _91id_93vEJFreBQW7Meta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/formProcesses/[id].vue?macro=true";
import { default as indexp4e1obdfZzMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/index.vue?macro=true";
import { default as parishAgeGroups1OW3qNaPZZMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue?macro=true";
import { default as parishBaseDatah4l4ZylRnUMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue?macro=true";
import { default as _91id_932raPxJJZ75Meta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/jugendzaehlt/parishes/[id].vue?macro=true";
import { default as indexj7ggYtoJ7tMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/jugendzaehlt/parishes/index.vue?macro=true";
import { default as parishesrA04hU91DTMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/jugendzaehlt/parishes.vue?macro=true";
import { default as regionActivitieslvjKdom4sIMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue?macro=true";
import { default as regionAgeGroupstWvPRNeWuEMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue?macro=true";
import { default as regionBaseDataM3BUHXdjnoMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue?macro=true";
import { default as regionDiaconiasteLB6wRwBlMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue?macro=true";
import { default as regionParishes1kEDymQ9GcMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue?macro=true";
import { default as _91id_93BhsIqVBfZOMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/jugendzaehlt/regions/[id].vue?macro=true";
import { default as indexk3mkzY4sFzMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/jugendzaehlt/regions/index.vue?macro=true";
import { default as regions8w8m8kxzUoMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/jugendzaehlt/regions.vue?macro=true";
import { default as jugendzaehltIp23gasDGSMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/jugendzaehlt.vue?macro=true";
import { default as paymentRunBaseDataGdEUf6d9gvMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue?macro=true";
import { default as paymentRunPaymentsL2NXVSyth4Meta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue?macro=true";
import { default as _91id_93sw6FWdmDheMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/payments/paymentRuns/[id].vue?macro=true";
import { default as indexEGG1shlXkeMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/payments/paymentRuns/index.vue?macro=true";
import { default as paymentsXpdrsPcVbZMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/payments.vue?macro=true";
import { default as processActivitieseVD0QrrY7MMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/processes/[id]/processActivities.vue?macro=true";
import { default as processBaseDatafdHYrGKPVMMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/processes/[id]/processBaseData.vue?macro=true";
import { default as _91id_93NNfsZMtFCGMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/processes/[id].vue?macro=true";
import { default as indexhDZLG29p3QMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/processes/index.vue?macro=true";
import { default as _91id_938vokHfJxSAMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/loginProviders/[id].vue?macro=true";
import { default as indexqS01LL6kEcMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/loginProviders/index.vue?macro=true";
import { default as loginProvidersPo3OccHomKMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/loginProviders.vue?macro=true";
import { default as organisationActivitiesz7SirIteHRMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/organisations/[id]/organisationActivities.vue?macro=true";
import { default as organisationAssociationSettingsyzwht50YgKMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue?macro=true";
import { default as organisationBaseDatafhhX9Dh3W8Meta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategories0zlWZcoLZfMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationEducationalConceptOS0bW8HXRFMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue?macro=true";
import { default as organisationTransferAgreement1E9wbqETV0Meta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUsers5rgRlFfxcXMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93sZ9J2SYjBmMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/organisations/[id].vue?macro=true";
import { default as indexZiGFwAI60nMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/organisations/index.vue?macro=true";
import { default as organisationsfIm1YBSIGSMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/organisations.vue?macro=true";
import { default as userActivitiesp28GMHGBXdMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/users/[id]/userActivities.vue?macro=true";
import { default as userBaseDataRe142MOy8JMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userSignatureL9TU93lOwAMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93o0DlJIef6UMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/users/[id].vue?macro=true";
import { default as indexPY6shzZRcZMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/users/index.vue?macro=true";
import { default as userslEVJ09IkijMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/users.vue?macro=true";
import { default as settingsqCHAxVWUr8Meta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings.vue?macro=true";
import { default as statisticProcessActivitiesiGZmIvEredMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue?macro=true";
import { default as statisticProcessBaseData1RqoKF8T7rMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue?macro=true";
import { default as _91id_93lW01SkhQ5SMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/statisticProcesses/[id].vue?macro=true";
import { default as indexbVKNLj5U5qMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/statisticProcesses/index.vue?macro=true";
import { default as service6JcC9RzSjVMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service.vue?macro=true";
import { default as language3kI4JAK0KKMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/settings/language.vue?macro=true";
import { default as organisationBaseDataOmN6i8GHt0Meta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategoriesYQqTS9Y2VsMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationTransferAgreementRi3L7Hbr7zMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUsersms62RiLLwpMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93tdEKHCDFxNMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/settings/organisations/[id].vue?macro=true";
import { default as userBaseDatanRUp20HjCEMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userSignaturexhegrPTXzjMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93fAKMUkvgAYMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/settings/users/[id].vue?macro=true";
import { default as indexm4ESHxBtvWMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/settings/users/index.vue?macro=true";
import { default as settingsNUnGG16ZpZMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/settings.vue?macro=true";
import { default as signature16wQut1samMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/signature.vue?macro=true";
import { default as sportbizzLkSKx7hAQmMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/sportbizz.vue?macro=true";
import { default as _91id_93vhnSE3saEIMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/statisticProcess/[id].vue?macro=true";
import { default as _91id_93mepf7h4nlWMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/statisticProcess/success/[id].vue?macro=true";
import { default as indexx2NtBz0e0iMeta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/statistics/index.vue?macro=true";
import { default as _91_46_46_46slug_93rf4Y6kZJH3Meta } from "/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/wiki/[...slug].vue?macro=true";
import { default as sportbizzk99AObOvrmMeta } from "@/pages/sportbizz.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93umUAI1cRkfMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/[...slug].vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: indexBt9vNM1XIqMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/auth/index.vue")
  },
  {
    name: "auth-social-organisation-provider",
    path: "/auth/social/:organisation()/:provider()",
    meta: indexf6QlPP6DCCMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/auth/social/[organisation]/[provider]/index.vue")
  },
  {
    name: "formProcess-id",
    path: "/formProcess/:id()",
    meta: _91id_93xbZYLrIaJ6Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/formProcess/[id].vue")
  },
  {
    name: "formProcess-success-id",
    path: "/formProcess/success/:id()",
    meta: _91id_935RK1yNB5hAMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/formProcess/success/[id].vue")
  },
  {
    name: "jugend-zaehlt-region",
    path: "/jugend-zaehlt/:region()",
    meta: _91region_93jAcnUBNKlVMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/jugend-zaehlt/[region].vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/news/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    meta: organisationsUE7aLGGlaHMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/organisations.vue")
  },
  {
    name: "processes",
    path: "/processes",
    meta: indexkl1AcByKNpMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/processes/index.vue"),
    children: [
  {
    name: "processes-index-grouped-by-events",
    path: "grouped-by-events",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/processes/index/grouped-by-events.vue")
  },
  {
    name: "processes-index-grouped-by-funding-programs",
    path: "grouped-by-funding-programs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/processes/index/grouped-by-funding-programs.vue")
  }
]
  },
  {
    name: "secret",
    path: "/secret",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/secret/index.vue"),
    children: [
  {
    name: "secret-index-dungeon",
    path: "dungeon",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/secret/index/dungeon.vue")
  },
  {
    name: "secret-index-inputs",
    path: "inputs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/secret/index/inputs.vue")
  }
]
  },
  {
    name: service6JcC9RzSjVMeta?.name,
    path: "/service",
    meta: service6JcC9RzSjVMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service.vue"),
    children: [
  {
    name: "service-basicData",
    path: "basicData",
    meta: basicDataG1qkpwsSSWMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData.vue"),
    children: [
  {
    name: "service-basicData-categories",
    path: "categories",
    meta: indexY0pcp4UwXHMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/categories/index.vue")
  },
  {
    name: "service-basicData-forms-id",
    path: "forms/:id()",
    meta: _91id_93wLsEzp3UPvMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/forms/[id].vue"),
    children: [
  {
    name: "service-basicData-forms-id-formBaseData",
    path: "formBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/forms/[id]/formBaseData.vue")
  },
  {
    name: "service-basicData-forms-id-formClass",
    path: "formClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/forms/[id]/formClass.vue")
  }
]
  },
  {
    name: "service-basicData-forms",
    path: "forms",
    meta: indexMMNRrKH1qtMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/forms/index.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id",
    path: "fundingPrograms/:id()",
    meta: _91id_93HDksljwQq4Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/fundingPrograms/[id].vue"),
    children: [
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramBaseData",
    path: "fundingProgramBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramProcessFields",
    path: "fundingProgramProcessFields",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramReports",
    path: "fundingProgramReports",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramRights",
    path: "fundingProgramRights",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue")
  }
]
  },
  {
    name: "service-basicData-fundingPrograms",
    path: "fundingPrograms",
    meta: index5JihjFTEqBMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/fundingPrograms/index.vue")
  },
  {
    name: "service-basicData-mails-id",
    path: "mails/:id()",
    meta: _91id_935DD3fqwysOMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/mails/[id].vue"),
    children: [
  {
    name: "service-basicData-mails-id-mailActivities",
    path: "mailActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/mails/[id]/mailActivities.vue")
  },
  {
    name: "service-basicData-mails-id-mailBaseData",
    path: "mailBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/mails/[id]/mailBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mails",
    path: "mails",
    meta: indexIVxVKvofRrMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/mails/index.vue")
  },
  {
    name: "service-basicData-mailTemplates-id",
    path: "mailTemplates/:id()",
    meta: _91id_93NitguLUdVbMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/mailTemplates/[id].vue"),
    children: [
  {
    name: "service-basicData-mailTemplates-id-mailTemplateActivities",
    path: "mailTemplateActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue")
  },
  {
    name: "service-basicData-mailTemplates-id-mailTemplateBaseData",
    path: "mailTemplateBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mailTemplates",
    path: "mailTemplates",
    meta: indexKSBNX1U2gTMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/mailTemplates/index.vue")
  },
  {
    name: "service-basicData-roles-name",
    path: "roles/:name()",
    meta: _91name_93uVMRs2GtFCMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/roles/[name].vue"),
    children: [
  {
    name: "service-basicData-roles-name-roleBaseData",
    path: "roleBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/roles/[name]/roleBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-roles",
    path: "roles",
    meta: indexN3IJqYJ6wPMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/roles/index.vue")
  },
  {
    name: "service-basicData-statisticForms-id",
    path: "statisticForms/:id()",
    meta: _91id_931FhTysK7VwMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/statisticForms/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticForms-id-statisticFormBaseData",
    path: "statisticFormBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormClass",
    path: "statisticFormClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormDedicatedForms",
    path: "statisticFormDedicatedForms",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue")
  }
]
  },
  {
    name: "service-basicData-statisticForms",
    path: "statisticForms",
    meta: indexipJBM4Dya1Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/statisticForms/index.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id",
    path: "statisticSurveys/:id()",
    meta: _91id_93Ap0AjUn9fFMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/statisticSurveys/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyActivities",
    path: "statisticSurveyActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyBaseData",
    path: "statisticSurveyBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyPeriods",
    path: "statisticSurveyPeriods",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue")
  }
]
  },
  {
    name: "service-basicData-statisticSurveys",
    path: "statisticSurveys",
    meta: indexrDjYRTNduIMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/statisticSurveys/index.vue")
  },
  {
    name: "service-basicData-statuses-id",
    path: "statuses/:id()",
    meta: _91id_93cqaVtgYAwoMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/statuses/[id].vue"),
    children: [
  {
    name: "service-basicData-statuses-id-statusActivities",
    path: "statusActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/statuses/[id]/statusActivities.vue")
  },
  {
    name: "service-basicData-statuses-id-statusBaseData",
    path: "statusBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/statuses/[id]/statusBaseData.vue")
  },
  {
    name: "service-basicData-statuses-id-statusNotifications",
    path: "statusNotifications",
    meta: statusNotificationsf8QSjtcSA4Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/statuses/[id]/statusNotifications.vue")
  }
]
  },
  {
    name: "service-basicData-statuses",
    path: "statuses",
    meta: indexwpqPgLNDfxMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/statuses/index.vue")
  },
  {
    name: "service-basicData-years-id",
    path: "years/:id()",
    meta: _91id_93lQqWff11HSMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/years/[id].vue"),
    children: [
  {
    name: "service-basicData-years-id-yearBaseData",
    path: "yearBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/years/[id]/yearBaseData.vue")
  },
  {
    name: "service-basicData-years-id-yearData",
    path: "yearData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/years/[id]/yearData.vue")
  }
]
  },
  {
    name: "service-basicData-years",
    path: "years",
    meta: indexKiqlrxtAwVMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/basicData/years/index.vue")
  }
]
  },
  {
    name: "service-formProcesses-id",
    path: "formProcesses/:id()",
    meta: _91id_93vEJFreBQW7Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/formProcesses/[id].vue")
  },
  {
    name: "service",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/index.vue")
  },
  {
    name: "service-jugendzaehlt",
    path: "jugendzaehlt",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/jugendzaehlt.vue"),
    children: [
  {
    name: parishesrA04hU91DTMeta?.name,
    path: "parishes",
    meta: parishesrA04hU91DTMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/jugendzaehlt/parishes.vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id",
    path: ":id()",
    meta: _91id_932raPxJJZ75Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/jugendzaehlt/parishes/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id-parishAgeGroups",
    path: "parishAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-parishes-id-parishBaseData",
    path: "parishBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-parishes",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/jugendzaehlt/parishes/index.vue")
  }
]
  },
  {
    name: regions8w8m8kxzUoMeta?.name,
    path: "regions",
    meta: regions8w8m8kxzUoMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/jugendzaehlt/regions.vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id",
    path: ":id()",
    meta: _91id_93BhsIqVBfZOMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/jugendzaehlt/regions/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id-regionActivities",
    path: "regionActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionAgeGroups",
    path: "regionAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionBaseData",
    path: "regionBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionDiaconias",
    path: "regionDiaconias",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionParishes",
    path: "regionParishes",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-regions",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/jugendzaehlt/regions/index.vue")
  }
]
  }
]
  },
  {
    name: "service-payments",
    path: "payments",
    meta: paymentsXpdrsPcVbZMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/payments.vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id",
    path: "paymentRuns/:id()",
    meta: _91id_93sw6FWdmDheMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/payments/paymentRuns/[id].vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id-paymentRunBaseData",
    path: "paymentRunBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue")
  },
  {
    name: "service-payments-paymentRuns-id-paymentRunPayments",
    path: "paymentRunPayments",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue")
  }
]
  },
  {
    name: "service-payments-paymentRuns",
    path: "paymentRuns",
    meta: indexEGG1shlXkeMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/payments/paymentRuns/index.vue")
  }
]
  },
  {
    name: "service-processes-id",
    path: "processes/:id()",
    meta: _91id_93NNfsZMtFCGMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/processes/[id].vue"),
    children: [
  {
    name: "service-processes-id-processActivities",
    path: "processActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/processes/[id]/processActivities.vue")
  },
  {
    name: "service-processes-id-processBaseData",
    path: "processBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/processes/[id]/processBaseData.vue")
  }
]
  },
  {
    name: "service-processes",
    path: "processes",
    meta: indexhDZLG29p3QMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/processes/index.vue")
  },
  {
    name: "service-settings",
    path: "settings",
    meta: settingsqCHAxVWUr8Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings.vue"),
    children: [
  {
    name: loginProvidersPo3OccHomKMeta?.name,
    path: "loginProviders",
    meta: loginProvidersPo3OccHomKMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/loginProviders.vue"),
    children: [
  {
    name: "service-settings-loginProviders-id",
    path: ":id()",
    meta: _91id_938vokHfJxSAMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/loginProviders/[id].vue")
  },
  {
    name: "service-settings-loginProviders",
    path: "",
    meta: indexqS01LL6kEcMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/loginProviders/index.vue")
  }
]
  },
  {
    name: organisationsfIm1YBSIGSMeta?.name,
    path: "organisations",
    meta: organisationsfIm1YBSIGSMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/organisations.vue"),
    children: [
  {
    name: "service-settings-organisations-id",
    path: ":id()",
    meta: _91id_93sZ9J2SYjBmMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/organisations/[id].vue"),
    children: [
  {
    name: "service-settings-organisations-id-organisationActivities",
    path: "organisationActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/organisations/[id]/organisationActivities.vue")
  },
  {
    name: "service-settings-organisations-id-organisationAssociationSettings",
    path: "organisationAssociationSettings",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue")
  },
  {
    name: "service-settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "service-settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "service-settings-organisations-id-organisationEducationalConcept",
    path: "organisationEducationalConcept",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue")
  },
  {
    name: "service-settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "service-settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "service-settings-organisations",
    path: "",
    meta: indexZiGFwAI60nMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/organisations/index.vue")
  }
]
  },
  {
    name: userslEVJ09IkijMeta?.name,
    path: "users",
    meta: userslEVJ09IkijMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/users.vue"),
    children: [
  {
    name: "service-settings-users-id",
    path: ":id()",
    meta: _91id_93o0DlJIef6UMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/users/[id].vue"),
    children: [
  {
    name: "service-settings-users-id-userActivities",
    path: "userActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/users/[id]/userActivities.vue")
  },
  {
    name: "service-settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "service-settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "service-settings-users",
    path: "",
    meta: indexPY6shzZRcZMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/settings/users/index.vue")
  }
]
  }
]
  },
  {
    name: "service-statisticProcesses-id",
    path: "statisticProcesses/:id()",
    meta: _91id_93lW01SkhQ5SMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/statisticProcesses/[id].vue"),
    children: [
  {
    name: "service-statisticProcesses-id-statisticProcessActivities",
    path: "statisticProcessActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue")
  },
  {
    name: "service-statisticProcesses-id-statisticProcessBaseData",
    path: "statisticProcessBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue")
  }
]
  },
  {
    name: "service-statisticProcesses",
    path: "statisticProcesses",
    meta: indexbVKNLj5U5qMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/service/statisticProcesses/index.vue")
  }
]
  },
  {
    name: "settings",
    path: "/settings",
    meta: settingsNUnGG16ZpZMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/settings.vue"),
    children: [
  {
    name: "settings-language",
    path: "language",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/settings/language.vue")
  },
  {
    name: "settings-organisations-id",
    path: "organisations/:id()",
    meta: _91id_93tdEKHCDFxNMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/settings/organisations/[id].vue"),
    children: [
  {
    name: "settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "settings-users-id",
    path: "users/:id()",
    meta: _91id_93fAKMUkvgAYMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/settings/users/[id].vue"),
    children: [
  {
    name: "settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "settings-users",
    path: "users",
    meta: indexm4ESHxBtvWMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/settings/users/index.vue")
  }
]
  },
  {
    name: "signature",
    path: "/signature",
    meta: signature16wQut1samMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/signature.vue")
  },
  {
    name: "sportbizz",
    path: "/sportbizz",
    meta: sportbizzLkSKx7hAQmMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/sportbizz.vue")
  },
  {
    name: "statisticProcess-id",
    path: "/statisticProcess/:id()",
    meta: _91id_93vhnSE3saEIMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/statisticProcess/[id].vue")
  },
  {
    name: "statisticProcess-success-id",
    path: "/statisticProcess/success/:id()",
    meta: _91id_93mepf7h4nlWMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/statisticProcess/success/[id].vue")
  },
  {
    name: "statistics",
    path: "/statistics",
    meta: indexx2NtBz0e0iMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/statistics/index.vue")
  },
  {
    name: "wiki-slug",
    path: "/wiki/:slug(.*)*",
    meta: _91_46_46_46slug_93rf4Y6kZJH3Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250520114410/client/pages/wiki/[...slug].vue")
  },
  {
    name: "sportbizz",
    path: "/index/welcome/p/sportbizz",
    meta: sportbizzk99AObOvrmMeta || {},
    component: () => import("@/pages/sportbizz.vue")
  }
]